<template>
  <div class="card add-bill-modifier has-rounded-top-corners">
    <div class="card-content add-bill-card-modifier">
      <div class="container has-text-weight-semibold has-text-centered">
        <h3 class="title is-4 has-baskerville-font has-text-brand-color mb-5">
          Edit Name
        </h3>
      </div>
      <div class="container">
        <label class="label mb-1">
          Editing <span class="has-text-info">"{{ name }}"</span>
        </label>
        <div class="control">
          <input
            class="input"
            v-bind:class="{'is-danger': isDuplicate}"
            type="text"
            placeholder="Enter new name..."
            v-model="newName"
            :disabled="loading"
            @input="$event.target.composing = false"
            @keyup.enter="submitEdit()"
          >
          <p v-if="isDuplicate" class="help is-danger mt-1">
            This name already exists.
          </p>
          <p v-if="errorMessage" class="help is-danger mt-1">
            {{ errorMessage }}
          </p>
          <div
            @click="submitEdit()"
            v-bind:class="{'is-loading': loading}"
            class="button is-info is-fullwidth mt-3 mb-3"
            :disabled="isSaveDisabled"
          >
            Save
          </div>
        </div>
        <div
          v-if="!loading"
          class="container mb-6 has-text-centered has-text-grey"
        >
          <div @click="cancel()" class="is-clickable is-unselectable back-button-modifier">
            back
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { masterFunction } from '@/firebase/init'

export default {
  name: 'EditName',
  props: ['name'],
  data() {
    return {
      loading: false,
      newName: '',
      errorMessage: null
    }
  },
  watch: {
    name: {
      immediate: true,
      handler(val) {
        this.newName = val || ''
      }
    }
  },
  computed: {
    event() {
      return this.$store.state.event
    },
    isDuplicate() {
      return (
        this.event &&
        this.newName.trim() !== this.name &&
        this.event.names.some(n => n === this.newName.trim())
      )
    },
    isSaveDisabled() {
      return (
        this.newName.trim().length === 0 ||
        this.loading ||
        this.isDuplicate ||
        this.newName.trim() === this.name
      )
    }
  },
  methods: {
    submitEdit() {
      const trimmed = this.newName.trim()
      if (this.isSaveDisabled) return
      this.loading = true
      this.errorMessage = null
      masterFunction({
        methodName: 'edit-name',
        eventId: this.event.eventId,
        oldName: this.name,
        newName: trimmed,
        adminKey: this.$store.state.adminKey
      }).then(() => {
        if (this.$store.state.name === this.name) {
          this.$store.commit('updateName', trimmed)
        }
        this.loading = false
        this.$emit('toggleEditNameScreen', trimmed)
      }).catch(err => {
        this.loading = false
        this.errorMessage = err.message || 'Something went wrong.'
      })
    },
    cancel() {
      if (!this.loading) {
        this.$emit('toggleEditNameScreen', null)
      }
    }
  }
}
</script>

<style>
</style>
